import React, { useReducer, useEffect, useRef } from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import { reducer, initialState, store } from './reducer';
import SearchDialog from './Dialog';
import axios from '../../../api/axios';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '1px',
    padding: theme.spacing(0, 1),
    border: '1px solid #c3c2c2',
    borderRadius: '4px',
    overflowX: 'hidden',
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    '& > div:not(:first-child)': {
      marginRight: theme.spacing(1),
    },
    '&:hover': {
      border: '1px solid black',
    },
  },
}));

const UsersChip = ({
  placeholder = 'انتخاب کاربر...',
  single = false,
  onChange,
  defaultUser = null,
}) => {
  const classes = useStyles();

  const mkState = (initialState) => {
    initialState.single = single;
    return initialState;
  };

  const [state, dispatch] = useReducer(reducer, initialState, mkState);
  const { users, search, page, limit } = state;
  const { Provider } = store;
  const timeoutId = useRef(null);
  const firstRender = useRef(true);

  const handleOpenDialog = () => {
    dispatch({ type: 'OPEN_DIALOG' });
  };
  const handleDelete = (userId) => {
    dispatch({ type: 'REMOVE_USER', payload: userId });
  };
  const handleSearching = async () => {
    try {
      const { data: results } = await axios.post(`/api/v1/admin/users/list`, {
        page,
        limit,
        query: search,
      });
      dispatch({ type: 'RESULTS', payload: results });
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ type: 'PROGRESS', payload: false });
    }
  };

  useEffect(() => {
    clearTimeout(timeoutId.current);
    dispatch({ type: 'PROGRESS', payload: true });
    timeoutId.current = setTimeout(() => handleSearching(), 2000);

    return () => {
      clearTimeout(timeoutId.current);
    };
  }, [search, page, limit]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      onChange(users);
    }
  }, [users]);


  return (
    <Provider value={{ state, dispatch }}>
      <SearchDialog fullWidth />
      <div className={classes.root} onClick={handleOpenDialog}>
        {users?.length === 0 && !defaultUser?.length ? (
          <span>{placeholder}</span>
        ) : !defaultUser?.length && users.length > 0 ? (
          users?.map((user) => (
            <Chip
              variant="outlined"
              color="primary"
              size="small"
              onDelete={() => handleDelete(user._id)}
              label={`${user?.firstName ? user.firstName + ' ' : ''}${
                user?.lastName ? user.lastName : ''
              }${user?.company ? `(${user.company})` : ''}`}
            />
          ))
        ) : (
          defaultUser.map((user) => (
            <Chip
              variant="outlined"
              color="primary"
              size="small"
              onDelete={() => handleDelete(user._id)}
              label={`${user?.firstName ? user.firstName + ' ' : ''}${
                user?.lastName ? user.lastName : ''
              }${user?.company ? `(${user.company})` : ''}`}
            />
          ))
        )}
      </div>
    </Provider>
  );
};

export default React.memo(UsersChip);
